{
  "selectAsField": "Pilih \"{value}\" sebagai {fieldName}",
  "typeToSearchField": "Taip untuk mencari {fieldName}",
  "licenseFieldLabel": "Pilih Plat Lesen (cth. 215BG2)",
  "licenseFieldName": "Plat Lesen",
  "licensePlaceholder": "Cari mengikut plat lesen",
  "dotFieldLabel": "Pilih Nombor DOT",
  "dotFieldName": "Nombor DOT",
  "dotPlaceholder": "Cari mengikut nombor DOT",
  "chooseOneOption": "Pilih salah satu pilihan di bawah"
}
